import type { FC } from "react";
import Driver from "../../models/Driver";
import { cn, panelInteractive, textHeading } from "@design-system";

interface DriverCardProps {
  driver: Driver;
  onClick: () => void;
  isSelected?: boolean;
}

export const DriverCard: FC<DriverCardProps> = ({
  driver,
  onClick,
  isSelected,
}) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        panelInteractive,
        "cursor-pointer py-2 px-3 w-full hover:shadow-md",
        isSelected ? "ring-2 ring-lgb-green-300" : "",
      )}
    >
      <h4 className={`text-sm font-medium ${textHeading} truncate text-center`}>
        {`${driver.firstName} ${driver.lastName}`}
      </h4>
    </div>
  );
};
